import { saveSubscription, loadSubscriptions, renewSubscription, activateSubscriptionService, resolveFreezeRequestService } from '../../../services/SubscriptionService.js';
export default {
    async createSubscription(context, subscriptionPayload) {
        const newSubscription = {
            userSelected: subscriptionPayload.userId,
            package: subscriptionPayload.packageClassId,
            paymentMethod: subscriptionPayload.paymentMethod,
            timeExpire: subscriptionPayload.timeExpire,
            dateExpired: subscriptionPayload.dateExpired
        }
        await saveSubscription(newSubscription, context.rootGetters['auth/getToken'], context.rootGetters['school/getSchoolId']);
        //context.commit('saveNewSubscription', {...newSubscription, _id: response.data.subscription._id});
        context.dispatch("students/loadStudents", {forceRefresh: true}, {root: true});
        context.dispatch("getSubscriptions", {forceRefresh: true});
    },
    async getSubscriptions(context, payload = false) {

        if (!payload.forceRefresh && !context.getters.shouldUpdate) return;

        const subscriptions = await loadSubscriptions(context.rootGetters['auth/getToken'], context.rootGetters['school/getSchoolId']);
        context.commit('setSubscriptions', subscriptions.data.subscriptions);
        context.commit('setFetchTimestamp');
    },
    setSubscriptionToRenew(context, subscriptions) {
        context.commit('setSubscriptionToRenew', subscriptions);
    },
    async renewSubscription(context, payload) {

        const rwSubscription = {
            subscriptionId: payload.subscriptionId,
            package: payload.package,
            paymentMethod: payload.paymentMethod,
            timeExpire: payload.timeExpire,
            dateExpired: payload?.dateExpired
        }
        
        await renewSubscription(rwSubscription, context.rootGetters['auth/getToken'], context.rootGetters['school/getSchoolId']);
        //context.dispatch("students/loadStudents", {forceRefresh: true}, {root: true});
        context.dispatch("getSubscriptions", {forceRefresh: true});
    },

    async activateSubscriptionAction(context, payload) {
        await activateSubscriptionService(payload, context.rootGetters['auth/getToken'], context.rootGetters['school/getSchoolId']);
        context.dispatch("getSubscriptions", {forceRefresh: true});
    },
    async resolveFreezeRequest(context, { schoolId, subId, requestId, action }) {
        await resolveFreezeRequestService(schoolId, subId, requestId, action, context.rootGetters['auth/getToken']);
        context.dispatch("getSubscriptions", {forceRefresh: true});
    }
}